import posthog from "posthog-js";
import {
  getAnalyticsConsent,
  shouldEnablePostHog,
} from "@/lib/analytics-consent";

type PostHogPropertyValue = string | number | boolean | null | undefined;

type PostHogProperties = Record<string, PostHogPropertyValue>;

function canCaptureAnalytics() {
  return shouldEnablePostHog(getAnalyticsConsent());
}

export function capturePostHogEvent(
  event: string,
  properties?: PostHogProperties,
) {
  if (!canCaptureAnalytics()) {
    return;
  }

  queueMicrotask(() => {
    try {
      posthog.capture(event, properties);
    } catch {
      // Analytics should never break the product flow.
    }
  });
}

export function capturePostHogException(
  error: unknown,
  properties?: PostHogProperties,
) {
  if (!canCaptureAnalytics()) {
    return;
  }

  queueMicrotask(() => {
    try {
      const errorToCapture =
        error instanceof Error ? error : new Error(String(error));
      posthog.captureException(errorToCapture, properties);
    } catch {
      // Analytics should never break the product flow.
    }
  });
}
